export default __webpack_public_path__ + "bg_anli_jinrong02561f7b.png";